<template>
  <div class="position-setting-form" style="margin-top:40px">
    <div class="bd-b">
      <el-form label-width="120px" ref="dataForm" :model="requertParams" :rules="rules">
        <div class="mb-10">
          <el-form-item class="d-ib" label="职位名称" prop="positionName">
            <el-input size="mini" v-model="requertParams.positionName" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item class="d-ib" label="职位备注">
            <el-input size="mini" v-model="requertParams.remark" style="width:300px"></el-input>
          </el-form-item>
        </div>
        <div class="mb-20 multiple-select">
          <el-form-item class="d-ib" label="职位员工">
            <el-select 
              v-model="requertParams.userIdList"
              multiple 
              @visible-change="openSelect"
              filterable
              :filter-method="filterFunction"
              size="mini" 
              style="width:724px"
              clearable>
              <el-option v-for="(item,index) in memberList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <setting-checkbox-form 
      :dataType="20" 
      :permissionConfigList='[requertParams.dataPermissionConfig]'
      :permissionList="requertParams.permissionList"
      @selectDataComponence="selectDataComponence"
      @selectPermisions="selectPermisions"></setting-checkbox-form>
    <div class="ta-c mt-10 mb-10">
      <el-button size="mini" @click="$emit('clearData')">取消</el-button>
      <el-button size="mini" type="primary" @click="submit('dataForm')">保存</el-button>
    </div>
  </div>
</template>

<script>
import settingCheckboxForm from '@/components/Setting/SettingCheckboxForm'
import {
  deepClone
} from '@/util'
import {
  Req_GetTeamerList,
  Req_PositionSubmit,
} from '@/request/organize'
export default {
  data() {
    return {
      memberList:[],
      copyMemberList:[],
      requertParams:{},
      rules:{
        positionName:[
          { required: true, message: '请输入职位名称', trigger: 'blur' }
        ]
      },
    }
  },
  props:{
    formData:{
      type:Object,
      default:() => {}
    }
  },
  created() {
    this.requertParams = deepClone(this.formData)
    this.getAllUser()
  },
  methods: {
    openSelect(e){
      this.memberList = this.copyMemberList
    },
    filterFunction(value){
      this.memberList = []
      const selectedItem = []
      if(!value) return this.memberList = this.copyMemberList
      this.copyMemberList.forEach(item => {
        const val = {
          data:item
        }
        if(this.$fuzzyFilter(val,value)){
          this.memberList.push(item)
        }else if(this.requertParams.userIdList.indexOf(item.userId) !== -1){
          selectedItem.push(item)
        }
      });
      this.memberList = [...this.memberList,...selectedItem]
    },
    submit(formName){
      this.$refs[formName].validate((valid) => {
        if(valid){
          const params = deepClone(this.requertParams)
          delete params.permissionList
          Req_PositionSubmit(params).then(res => {
            this.$message.success(this.requertParams.positionId ? '修改成功' : '新增成功')
            this.$emit('refreshTreeList')      
          }).catch(err => this.$catchErr(err))
        }else{
          this.$message.error('请补全所需信息')
          return false
        }
      })
    },
    getAllUser(){
      Req_GetTeamerList().then(res => {
        this.memberList = deepClone(res)
        this.copyMemberList = deepClone(res)
      }).catch(err => this.$catchErr(err))
    },
    selectDataComponence(idList){
      this.requertParams.dataPermissionConfig = idList.join('')
    },
    selectPermisions(idList,mapList){
      const newList = []
      idList.forEach(item => {
        if(mapList[item].pid !== 0 && idList.indexOf(mapList[item].pid) === -1 && newList.indexOf(mapList[item].pid) === -1){
          newList.push(mapList[item].pid)
        }
      });
      this.requertParams.permissionIdList = [...idList,...newList]
    },
  },
  computed:{

  },
  watch:{
    formData(nV){
      this.requertParams = deepClone(nV)
      this.getAllUser()
    }
  },
  components:{
    settingCheckboxForm
  }
}
</script>

<style lang="scss">
.position-setting-form{
  .multiple-select{
  }  
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/PositionSettingForm.vue